import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type CreateApiKeyResponse = {
  id: string;
  name: string;
  rawKey: string;
  createdAt: string | null;
  lastUsedAt: string | null;
  revokedAt: string | null;
};

export const useCreateTenantApiKey = (companyId?: string) => {
  const queryClient = useQueryClient();

  const resource = companyId ? `admin/companies/${companyId}/api-keys` : 'dev-tools/api-keys';
  const queryKey = companyId
    ? ['admin', 'companies', companyId, 'api-keys']
    : ['dev-tools', 'api-keys'];

  const {
    mutateAsync,
    isPending: isLoading,
    error,
    reset,
  } = useMutation<{ data: CreateApiKeyResponse }, Error, { name: string }>({
    mutationFn: ({ name }) => api.post<CreateApiKeyResponse>(resource, { name }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return { createKey: mutateAsync, isLoading, error, reset };
};
